module.exports = __webpack_public_path__ + "static/media/reqi.0bfbd8fb.jpg";